
<!-- 课件页面 显示ppt课件-->
<template>
  <div class="container">

    <iframe :src="lessonURL" width="100%" height="100%" id="view_course" frameborder="no" border="0"></iframe>

    <div @click="back">
      <img src="../assets/exit-2.jpg" class="turn" style="  position: fixed;left: 0px;top: 0px;width: 80px;height:80px;z-index:9999; " id="musicStopIco">
    </div>


      <!-- 刷新按钮-->
      <div @click="refreshPages">
        <img src="../assets/refresh-2.jpg" class="turn" style="  position: fixed;right: 0px;top: 0px;width: 80px;height:80px;z-index:9999;border-radius:100px; " id="musicStopIco">
      </div>
    <div style="position: fixed;top: 10px;">
      <div v-if="isMove1" class="main1" id="username">{{username}}&nbsp;



      </div>
      <div v-if="isMove2" class="main2">{{username}}&nbsp;
      </div>

      <div v-if="isMove3" class="main3">{{username}}
      </div>
    </div>


    <div class="modalBox" :style="{'display':modalsShow}">

      <div style="position: fixed;right: 16%;top: 16%;" @click="hiddenModal">
        <img src="../assets/del.png" width="30px;">
      </div>
      <img src="../assets/wx/5.png" width="80%" style="margin-top: 60px;">

    </div>
  </div>
</template>

<script>
  import myHttp from '../utils/http'
  export default {
    name: "Lesson",
    data:function(){
      return{
        lessonURL:'',
        modalsShow:'none',
        username:'',
        isMove1:true,
        isMove2:false,
        isMove3:false,
        count:1,
      }
    },
    mounted() {

      window.scrollTo(0,0);
      this.getLessonURL();  //获取课程地址
      this.isShow();//判断是否显示弹出框

      let date = new Date();
      let str_date =date.toLocaleString();
      //获取用户名
      this.username = str_date+'  '+window.localStorage.getItem('username')+' 上课中...';

      this.myMove();
    },
    methods:{
      back(){
        this.$router.back();
      },
      getLessonURL(){
        let course_id =this.$route.query.course_id;
        let user_id =window.localStorage.getItem('id');
        let lesson_id =this.$route.query.lesson_id;

        myHttp.get(this.GLOBAL.serverURL+'api/app/courseurl',{
          params:{
            course_id:course_id,
            user_id:user_id,
            lesson_id:lesson_id,
            token:window.localStorage.getItem('token')
          }
        }).then(res =>{
          // if((res.config.headers.authorization!=undefined)||(res.config.headers.authorization!='')){
          //    window.localStorage.setItem('token',res.config.headers.authorization);
          // }else{
          //   if((res.config.params.token!=undefined)||(res.config.params.token!=''))
          //   window.localStorage.setItem('token',res.config.params.token);
          // }

          // window.localStorage.setItem('token',res.headers.token);
          console.log(res.data[0].ret)
          if(res.data[0].ret=='2001'){
            console.log('没有购买');
            this.$router.replace("/404");
          }
          this.lessonURL=res.data[1].url;
        }).catch( err =>{
          console.log('%c catch...','color:red;font-size:15px;');
          console.log(err);
        }).finally( e =>{

        })
      },
      
      // 刷新页面
      refreshPages(){
       this.$router.push('/refresh');
      },
      showModal(){
        this.modalsShow='inline';
      },
      hiddenModal(){
        this.modalsShow='none';
      },

      isShow(){
        let course_num =window.localStorage.getItem('course_num');
        let lesson =window.localStorage.getItem('lesson');
        if(course_num=='qz101'&&(lesson=='S1'||lesson=='S2')){
          //第一系列课 前两个s 不提示购买课程
          this.modalsShow='none';
        }else{
          this.modalsShow='none';
        }
      },

      addClass() {


        /**
         *
         * 随机运动
         * **/




        /**
         *
         *
         * 弹幕运动
         */

        let n =parseInt(4*Math.random());

        if(n==1){
          this.isMove1 =true;
          this.isMove2 =false;
          this.isMove3 =false;
          // console.log('运动1。。。');
        }else if(n==2){
          this.isMove1 =false;
          this.isMove2 =true;
          this.isMove3 =false;
          // console.log('运动2。。。');
        }else if(n==3) {
          this.isMove1 =false;
          this.isMove2 =false;
          this.isMove3 =true;
          // console.log('运动3。。。');
        }else{
          this.isMove1 =true;
          this.isMove2 =false;
          this.isMove3 =false;
          // console.log('消失。。。');
        }

        // main.classList.add('main2');
        // console.log('改变class。。。',n);

        let date = new Date();
        let str_date =date.toLocaleString();


        //获取用户名
        this.username = str_date+'  '+window.localStorage.getItem('username')+' 上课中...';
      },

      myMove(){
        setInterval(this.addClass,20*1000);
      },

      getDate(){

      }
    },

  }


</script>

<style scoped>
  *{
    margin: 0;
    padding: 0;
  }

  html,body{
    width: 100%;
    height: 100%;

  }

  .container{
    width: 100%;
    height: 100%;
    /*background-color: #ced1d3;*/
  }
  .modalBox{
    position: fixed;
    background-color: #f8faf4;
    width: 70%;
    height: 70%;
    left: 15%;
    top:15%;
    overflow: auto;
    box-shadow: 0px 0px 10px 5px #232122;
  }

  .username{
    position: fixed;
    top: 25px;
    color: #00000036;
    white-space: nowrap;
    font-size: 0.5em;
    /*transform: rotate(3rad);*/
    animation-name: move2;
    animation-duration: 65s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }

  .username2{
    position: fixed;
    top: 40px;
    color: #0000000d;
    white-space: nowrap;
    font-size: 0.5em;
  }
  .username3{
    position: fixed;
    top: 55px;
    color: #0000000d;
    white-space: nowrap;
    font-size: 0.5em;
  }

  .username4{
    position: fixed;
    bottom: 140px;
    color: #00000021;
    white-space: nowrap;
    font-size: 0.5em;
    transform: rotate(-17deg);
    -webkit-user-select: none;
    /*background-color: bisque;*/
    animation-name: move;
    animation-duration: 65s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-delay: 5s;
  }

  /*.username4:hover{*/
  /*  animation: 1s move;*/
  /*}*/

  @-webkit-keyframes  move {
    0% {
      /*background-color: black;*/
      position: fixed;
      bottom: 100px;
    }

    20% {
      position: fixed;
      bottom: 200px;
    }
    40% {
      position: fixed;
      bottom: 300px;
    }
    60%{
      position: fixed;
      bottom: 400px;
    }
    80%{
      position: fixed;
      bottom: 500px;
    }
    100% {
      /*background-color: #42b983;*/
      position: fixed;
      bottom: 600px;
    }
  }


  @-webkit-keyframes move2 {
    0%{
      position: fixed;
      left: 20px;
      top: 20px;
      color: #42b983;
    }

    25%{
      position: fixed;
      left: 350px;
      top: 50px;
      color: #42b983;
    }

    50%{
      position: fixed;
      left: 750px;
      top: 100px;
      color: black;
    }
    75%{
      position: fixed;
      left: 1420px;
      top: 120px;
      color: #bf6d1c;
    }
  }

  @-webkit-keyframes move-1 {
    0%{
      left: 0px;
      top: 100px;
    }
    100%{
      left: 1300px;
      top: 100px;
    }
  }

  @-webkit-keyframes move-2 {
    /*0% { right: 20px; top: 20px;}*/
    /*25% { right: 220px; top: 220px;}*/
    /*50% { right: 620px; top: 620px;}*/
    /*75% { right: 220px; top:220px;}*/
    /*100% { right: 20px; top: 20px;}*/
    0%{
      left: 0px;
      top: 80px;
    }
    100%{
      left: 1300px;
      top: 80px;
    }
  }

  @-webkit-keyframes move-3 {
    /*0% { right: 20px; bottom: 20px;}*/
    /*25% { right: 220px; bottom: 220px;}*/
    /*50% { right: 620px; bottom: 620px;}*/
    /*75% { right: 220px; bottom:220px;}*/
    /*100% { right: 20px; bottom: 20px;}*/

    0%{
      left: 0px;
      top: 140px;
    }
    100%{
      left: 1300px;
      top: 140px;
    }
  }
  @-webkit-keyframes move-4 {
    0% { left: 20px; bottom: 20px;}
    25% { left: 220px; bottom: 220px;}
    50% { left: 620px; bottom: 620px;}
    75% { left: 220px; bottom:220px;}
    100% { left: 20px; bottom: 20px;}
  }

  .main1{
    width: 400px;
    height: 100px;
    -webkit-animation: move-1 40s;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-delay: 1s;
    -webkit-animation-timing-function: linear;
    position: absolute;
    color: #0f061329;
  }

  .main2{
    width: 400px;
    height: 100px;
    -webkit-animation: move-2 40s;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-delay: 1s;
    -webkit-animation-timing-function: linear;
    position: absolute;
    color: #0f061329;
  }

  .main3{
    width: 400px;
    height: 100px;
    -webkit-animation: move-3 40s;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-delay: 1s;
    -webkit-animation-timing-function: linear;
    position: absolute;
    color: #0f061329;
  }

  .main4{
    -webkit-animation: move-4 40s;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-delay: 1s;
    -webkit-animation-timing-function: linear;
    position: absolute;
    /*background-color: cadetblue;*/
  }

  .mian5{
    position: absolute;
    left: 0px;
    top: 0px;
    display: none;
    color: #dda688;
  }
</style>



// WEBPACK FOOTER //
// src/views/Lesson.vue